import { sendUtagEvent } from '../../core/analytics/utag_events'
import on from '../../utils/events_delegation'
import { getCleanedString } from '../../utils/utilities'

export function initializeUtagEvents() {
  on({
    eventName: 'click',
    selector: '.introduction-module .apply-code',
    handler() {
      const element = this
      const event_lbl = element.parentElement.querySelector('.offer-code .code-number .code').innerHTML
      sendUtagEvent({
        data: {
          event_name: 'offers_apply',
          event_cat: 'offers',
          event_act: 'apply offer',
          event_lbl: getCleanedString(event_lbl),
          event_purpose: 'booking',
          event_structure: 'body',
        },
      })
    },
  })

  on({
    eventName: 'click',
    selector: '.introduction-module-layer .utag-see-more-link',
    handler() {
      const element = this
      const parentElement = element.closest('.introduction-module-layer')?.querySelector('[data-utag-block-title]')
        ?.dataset?.utagBlockTitle
      const event_cat = 'introduction module'
      const event_act = 'see more'
      const event_lbl = parentElement

      sendUtagEvent({
        data: {
          event_name: 'introduction_module',
          event_cat,
          event_act,
          event_lbl: getCleanedString(event_lbl || ''),
          event_purpose: 'information',
          event_structure: 'body',
        },
      })
    },
  })
}
